import {
  Nullable,
  OfficeChat,
  SetStateType,
  ChatSectionProps,
  ChatParseOptions,
  OfficeChatPuprose,
  StandardButtonProps,
} from '@gv/triage-components';

import { ChatDialogActionType } from '../types';

export interface ChatRoomProps {
  isNew?: boolean;
  video?: boolean;
}

export enum RightSectionType {
  ViewCase = 'View case',
  ChatReport = 'Chat report',
  CreateCase = 'Create case',
  CreateTask = 'Create task',
  PlaceBack = 'Place back in queue',
  SendPaymentLink = 'Send payment link',
}

export type SectionType = Nullable<RightSectionType>;

export interface CommonProps {
  sectionType: SectionType;
  setSectionType: SetStateType<SectionType>;
}

export interface RightSectionProps
  extends Pick<ChatSectionProps, 'mentionUsers' | 'onMentionClick'> {
  hasVideo: boolean;
  threadId?: string;
  chat?: OfficeChat;
  onClose: () => void;
  isVirtualExam?: boolean;
  sectionType: SectionType;
}

export interface GetButtonsProps extends Omit<CommonProps, 'sectionType'> {
  caseId?: number;
  isCompact: boolean;
  isVirtualExam?: boolean;
  hasPaymentPermission?: boolean;
  chatPurpose?: OfficeChatPuprose;
  setActionType: (value: ChatDialogActionType) => void;
}

export interface GetHeaderButtonsProps {
  mobile?: boolean;
  tablet?: boolean;
  chat?: OfficeChat;
  isAdmin?: boolean;
  onMute: () => void;
  isPetOwner: boolean;
  onExport: () => void;
  onTransfer: () => void;
  onAddMember: () => void;
  onVideoCall?: () => void;
  onDeleteChat?: () => void;
  parseOptions: ChatParseOptions;
}

export interface ChatButton extends Omit<StandardButtonProps, 'text'> {
  text: RightSectionType | ChatDialogActionType;
}

export enum AblyVideoEvent {
  Ended = 'call:stop',
  Started = 'call:start',
  HostLeave = 'host:leave',
  HostJoined = 'host:joined',
}
